module.exports = __webpack_public_path__ + "img/ggtgb.21e721b3.png";